export default __webpack_public_path__ + "static/media/raiser_loader.dad9a020.gif";